// firebaseAuthWeb.js
import { initializeApp } from "firebase/app";
import { getAuth, indexedDBLocalPersistence, setPersistence } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDz6rPUQAATzYiusZ-eKzMIzRsFLYfrUh0",
  authDomain: "nutrisearch-6b83a.firebaseapp.com",
  projectId: "nutrisearch-6b83a",
  storageBucket: "nutrisearch-6b83a.firebasestorage.app",
  messagingSenderId: "1041058281114",
  appId: "1:1041058281114:web:2f86f485c42a6ab9251123",
  measurementId: "G-LL4FBK8B9J"
};


export const app = initializeApp(firebaseConfig); // ✅ export app
export const auth = getAuth(app);

setPersistence(auth, indexedDBLocalPersistence);

export default auth; // for default import


